export const initHomeBrands = (container: HTMLElement) => {
    const groups = container.querySelectorAll<HTMLElement>('[data-brand-group]');
    let current = 0;
    const switchInterval = 6000;
    const perLogoDelay = 150;
    const fadeOutTime = 600;
    const fadeInTime = 600;

    const applyTransition = (el: HTMLElement, time: number) => {
        el.style.transition = `all ${time}ms ease`;
    };
    const removeTransition = (el: HTMLElement) => {
        el.style.transition = `none`;
    };

    const hideGroup = (index: number): number => {
        const group = groups[index];
        const logos = group.querySelectorAll<HTMLElement>('.logo');

        logos.forEach((logo, j) => {
            const delay = j * perLogoDelay;
            setTimeout(() => {
                applyTransition(logo, fadeOutTime);
                logo.style.opacity = '0';
                logo.style.transform = 'translateY(30px)';
                logo.style.pointerEvents = 'none';
            }, delay);
        });

        return (logos.length - 1) * perLogoDelay + fadeOutTime;
    };

    const showGroup = (index: number) => {
        groups.forEach((group, i) => {
            group.style.opacity = i === index ? '1' : '0';
            group.style.pointerEvents = i === index ? 'auto' : 'none';
        });

        const group = groups[index];
        const logos = group.querySelectorAll<HTMLElement>('.logo');

        logos.forEach((logo, j) => {
            const delay = j * perLogoDelay;
            removeTransition(logo);
            logo.style.opacity = '0';
            logo.style.transform = 'translateY(-60px)';
            logo.style.pointerEvents = 'auto';

            setTimeout(() => {
                applyTransition(logo, fadeInTime);
                logo.style.opacity = '1';
                logo.style.transform = 'translateY(0)';
            }, delay + 100);
        });
    };

    groups.forEach((group, i) => {
        group.style.opacity = i === current ? '1' : '0';
        group.style.transition = 'opacity 300ms ease';
        group.style.pointerEvents = i === current ? 'auto' : 'none';

        const logos = group.querySelectorAll<HTMLElement>('.logo');
        logos.forEach(logo => {
            logo.style.opacity = '0';
            logo.style.transform = 'translateY(10px)';
        });
    });

    showGroup(current);

    setInterval(() => {
        const waitTime = hideGroup(current);
        setTimeout(() => {
            current = (current + 1) % groups.length;
            showGroup(current);
        }, waitTime);
    }, switchInterval);
};